import { NO_PROXIMITY } from './Proximity.reducer';

export const getProximitySelection = (state) => state.proximity;

export const getProximityActiveLayer = (state) => state.proximity?.activeLayer;

export const getIsProximityActive = (state) => {
  const activeLayer = state.proximity?.activeLayer;
  return Boolean(activeLayer) && activeLayer !== NO_PROXIMITY;
};

export const getLastAppliedProximity = (state) => state.proximity?.lastApplied;
